import { useTranslation } from "react-i18next";

interface InFlightCardProps {
  prompt: string;
  onAbort: () => void;
}

const Spinner = () => (
  <svg
    className="animate-spin h-4 w-4 text-green-500"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
  </svg>
);

export const InFlightCard = ({ prompt, onAbort }: InFlightCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-md border border-green-100 bg-green-50 p-2 mb-2">
      <div className="flex items-center gap-2">
        <Spinner />
        <span className="text-xs font-medium text-green-700">
          {t("general.assistantScenarIa.inFlightLabel")}
        </span>
      </div>
      {prompt && <div className="mt-1 text-[11px] text-gray-600 italic truncate">“{prompt}”</div>}
      <button
        type="button"
        className="mt-2 text-[11px] text-gray-600 hover:text-gray-800 underline"
        onClick={onAbort}
      >
        {t("general.assistantScenarIa.abort")}
      </button>
    </div>
  );
};

export default InFlightCard;
